import React, { useState, useEffect } from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import cardIcon from '../../assets/icon-atom.svg';
import Button from '../Button';
import AgentCard from '../AgentCard';
import CenterModal from '../Modal/CenterModal';
import CreatAgentModal from '../CreatAgentModal';
import agentService from '../../services/agentService';
import AgentSuccessModal from '../AgentSuccessModal';
import { AgentsSectionStyled, PageHeader, AgentCardHolder } from './AgentsSection.styles';
import Loaders from '../Loaders';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import FeedaAgents from './FeedaAgents';
import Toast from '../Toast';
import { useQuery } from '@tanstack/react-query';
import Field from '../Field';

const AgentsSection = () => {
  const [filterName, setFilterName] = useState(null);
  const [successModal, setSuccessModal] = useState(false);
  const [agentModal, setAgentModal] = useState(false);
  const [activeTab, setActiveTab] = useState('my-agents');
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));

  const getAllAgentData = useQuery({
    queryKey: ['get-all-agents'],
    queryFn: () => agentService.getAllAgent(),
    staleTime: Infinity,
  });

  function agentLimit() {
    Toast({
      type: 'info',
      message: 'Agent limit exceed',
    });
  }

  return (
    <>
      <CenterModal width="500" title="Agent Created!" open={successModal} setOpen={setSuccessModal}>
        <AgentSuccessModal />
      </CenterModal>
      <CenterModal width="1000" title="Create New Custom Agent" open={agentModal} setOpen={setAgentModal}>
        <CreatAgentModal setSuccessModal={setSuccessModal} onClose={() => setAgentModal(false)} />
      </CenterModal>
      <AgentsSectionStyled>
        <PageHeader>
          <div className="text-box">
            <h1>Agents</h1>
            <p>Create and explore custom AI agents with tailored instructions and diverse skills.</p>
          </div>

          <Button
            variant="secondary"
            width="160px"
            onClick={() => {
              getAllAgentData?.data?.agents?.length >= user?.plan?.agent_creation_limit
                ? agentLimit()
                : setAgentModal(true);
            }}>
            <AiOutlinePlusCircle size="18" /> Create Agent
          </Button>
        </PageHeader>
        <ul className="filter-list">
          <li>
            <button
              className={`btn-filter ${activeTab === 'my-agents' ? 'active' : ''}`}
              type="button"
              onClick={() => setActiveTab('my-agents')}>
              my agents
            </button>
          </li>
          <li>
            <button
              className={`btn-filter ${activeTab === 'feeda-agents' ? 'active' : ''}`}
              type="button"
              onClick={() => setActiveTab('feeda-agents')}>
              discover
            </button>
          </li>
        </ul>

        {/* Show only the active section */}
        {activeTab === 'my-agents' && (
          <div className="my-agents">
            <div className="input-wrapper">
              <Field
                type="text"
                placeholder="Search agent by name"
                name="searchAgent"
                onChange={({ target }) => setFilterName(target?.value)}
              />
            </div>
            <AgentCardHolder>
              {getAllAgentData.isPending ? (
                <Loaders viewLoader />
              ) : (
                <AgentCard
                  agentCardsData={getAllAgentData?.data?.agents}
                  removeDelete={true}
                  aiAgents={false}
                  filterName={filterName}
                  setSuccessModal={setSuccessModal}
                />
              )}
            </AgentCardHolder>
          </div>
        )}

        {activeTab === 'feeda-agents' && (
          <div className="feeda-agents">
            <FeedaAgents />
          </div>
        )}
      </AgentsSectionStyled>
    </>
  );
};

export default AgentsSection;
